interface InstantMessageDetails {
  subject: string;
  message: string;
  sender_name: string;
  sender_email: string;
  image_url:string;
  event_title?: string;
  event_id?: string;
  base_url: string;
}

export function getInstantMessageEmailTemplate(details: InstantMessageDetails) {
  const subject = `${details.subject} - Mensaje de ${details.sender_name}`;
  
  const body = `
    <!DOCTYPE html>
    <html>
    <head>
      <meta charset="utf-8">
      <meta name="viewport" content="width=device-width, initial-scale=1.0">
      <title>${subject}</title>
      <style>
        body {
          font-family: 'Helvetica Neue', Arial, sans-serif;
          line-height: 1.6;
          color: #333;
          margin: 0;
          padding: 0;
          background-color: #f9f9f9;
        }
        .email-container {
          max-width: 600px;
          margin: 0 auto;
          background-color: #ffffff;
          border-radius: 8px;
          overflow: hidden;
          box-shadow: 0 4px 8px rgba(0,0,0,0.05);
        }
        .header {
          background-color: #4C66EF;
          padding: 30px 0;
          text-align: center;
        }
        .logo {
          max-width: 150px;
          height: auto;
        }
        .content {
          padding: 30px;
        }
        h1 {
          color: #333;
          margin-top: 0;
          font-size: 24px;
        }
        .message-box {
          background-color: #f5f7fa;
          padding: 20px;
          border-radius: 6px;
          margin: 20px 0;
          border-left: 4px solid #4C66EF;
        }
        .sender-info {
          background-color: #e8f4f8;
          padding: 15px;
          border-radius: 6px;
          margin: 20px 0;
          font-size: 14px;
        }
        .sender-label {
          font-weight: bold;
          color: #666;
          margin-bottom: 5px;
        }
        .event-info {
          background-color: #fff8e1;
          padding: 15px;
          border-radius: 6px;
          margin: 20px 0;
          font-size: 14px;
          border: 1px solid #fdd835;
        }
        .cta-button {
          display: inline-block;
          background-color: #4C66EF;
          color: white !important;
          text-decoration: none;
          padding: 14px 30px;
          border-radius: 6px;
          font-weight: bold;
          margin-top: 20px;
          text-align: center;
        }
        .footer {
          padding: 20px 30px;
          text-align: center;
          font-size: 12px;
          color: #999;
          border-top: 1px solid #eee;
        }
        @media only screen and (max-width: 500px) {
          .content {
            padding: 20px;
          }
        }
      </style>
    </head>
    <body>
      <div class="email-container">
        <div class="header">
          ${details.image_url ? `<img src="${details.image_url}" alt="${details.subject}" class="event-image">` : ''}
        </div>
        <div class="content">
          <h1>${details.subject}</h1>
          
          <div class="sender-info">
            <div class="sender-label">Mensaje de:</div>
            <div><strong>${details.sender_name}</strong> (${details.sender_email})</div>
          </div>
          
          ${details.event_title ? `
            <div class="event-info">
              <div class="sender-label">Relacionado con el evento:</div>
              <div><strong>${details.event_title}</strong></div>
            </div>
          ` : ''}
          
          <div class="message-box">
            <p style="margin: 0; white-space: pre-line;">${details.message}</p>
          </div>
          
          ${details.event_id ? `
            <a href="${details.base_url}/events/${details.event_id}/manage" class="cta-button">Ver evento</a>
          ` : ''}
          
          <p style="margin-top: 30px; font-size: 14px; color: #666;">
            Este mensaje fue enviado por Punta Tech Meetup. Respondé directamente a ${details.sender_email} si necesitás hacerlo.
          </p>
        </div>
        <div class="footer">
          <p>Este mensaje fue enviado a través del sistema de mensajería instantánea de Punta Tech Meetup.</p>
        </div>
      </div>
    </body>
    </html>
  `;

  return { subject, body };
}